module.exports = __webpack_public_path__ + "static/media/icon-hands.48be644c.svg";